module.exports = __webpack_public_path__ + "img/viv_book.fc9d5a5f.jpg";